import { jsx as a, jsxs as C } from "react/jsx-runtime";
import { Autocomplete as A, TextField as p, Checkbox as w, FormControl as x, FormLabel as y, FormGroup as G, FormControlLabel as B, FormHelperText as k, RadioGroup as S, Radio as $, Switch as E, Box as F } from "@mui/material";
import { useController as m } from "react-hook-form";
const _ = ({
  control: h,
  name: u,
  rules: s,
  textFieldProps: n,
  multiple: r,
  valueToOption: l,
  optionToValue: f,
  loading: i,
  ...R
}) => {
  const { field: o, fieldState: c } = m({ control: h, name: u, rules: s });
  let e = o.value;
  return e === void 0 ? e = null : e && l && (i ? e = r ? [] : null : r ? (Array.isArray(e) || (console.warn("Received a non-array value for a multiple Autocomplete"), e = []), e = e.map(l).filter((d) => d != null)) : r || (e = l(e))), /* @__PURE__ */ a(
    A,
    {
      onChange: (d, t) => {
        if (!(f && t)) {
          o.onChange(t);
          return;
        }
        if (!r) {
          o.onChange(f(t));
          return;
        }
        if (Array.isArray(t)) {
          o.onChange(t.map(f));
          return;
        }
        console.warn("Autocomplete is set to multiple but value is an not array");
      },
      value: e,
      multiple: r,
      loading: i,
      renderInput: (d) => {
        var t;
        return /* @__PURE__ */ a(
          p,
          {
            ...n,
            ...d,
            error: !!c.error,
            onBlur: o.onBlur,
            helperText: ((t = c.error) == null ? void 0 : t.message) ?? (n == null ? void 0 : n.helperText),
            inputRef: o.ref
          }
        );
      },
      ...R
    }
  );
}, J = _, T = ({
  control: h,
  name: u,
  ...s
}) => {
  const { field: n } = m({ control: h, name: u });
  let r = n.value;
  if (r == null)
    r = !1;
  else if (typeof r != "boolean")
    throw new Error("RhfCheckbox value must be boolean, null or undefined");
  return /* @__PURE__ */ a(
    w,
    {
      checked: r,
      onChange: (l, f) => {
        n.onChange(f);
      },
      onBlur: n.onBlur,
      ref: n.ref,
      ...s
    }
  );
}, K = T, j = ({
  control: h,
  name: u,
  rules: s,
  label: n,
  options: r,
  helperText: l,
  formLabelProps: f,
  formGroupProps: i,
  ...R
}) => {
  var t;
  const { field: o, fieldState: c } = m({ control: h, name: u, rules: s });
  let e = o.value;
  if (e == null)
    e = [];
  else if (!Array.isArray(e))
    throw new Error("RhfCheckboxGroup value must be array, null or undefined");
  const d = (v, g) => {
    if (!g) {
      o.onChange(
        e.filter((b) => b !== v)
      );
      return;
    }
    o.onChange([...e, v]);
  };
  return /* @__PURE__ */ C(
    x,
    {
      error: c.invalid,
      component: "fieldset",
      variant: "standard",
      ref: o.ref,
      ...R,
      children: [
        /* @__PURE__ */ a(y, { component: "legend", ...f, children: n }),
        /* @__PURE__ */ a(G, { ...i, children: r.map((v) => /* @__PURE__ */ a(
          B,
          {
            name: v.value,
            checked: e.includes(v.value),
            onChange: (g, b) => {
              d(v.value, b);
            },
            control: /* @__PURE__ */ a(w, {}),
            label: v.label
          },
          v.value
        )) }),
        (l || c.error) && /* @__PURE__ */ a(k, { children: ((t = c.error) == null ? void 0 : t.message) ?? l })
      ]
    }
  );
}, M = j, L = ({
  control: h,
  name: u,
  rules: s,
  label: n,
  options: r,
  helperText: l,
  formLabelProps: f,
  radioGroupProps: i,
  ...R
}) => {
  var d;
  const { field: o, fieldState: c } = m({ control: h, name: u, rules: s });
  let e = o.value;
  if (e == null)
    e = null;
  else if (typeof e != "string")
    throw new Error("RhfRadioGroup value must be string, null or undefined");
  return /* @__PURE__ */ C(
    x,
    {
      error: !!c.error,
      variant: "standard",
      ref: o.ref,
      ...R,
      children: [
        /* @__PURE__ */ a(y, { ...f, children: n }),
        /* @__PURE__ */ a(
          S,
          {
            ...i,
            name: u,
            onChange: (t, v) => {
              o.onChange(v);
            },
            onBlur: o.onBlur,
            value: e,
            children: r.map((t) => /* @__PURE__ */ a(
              B,
              {
                value: t.value,
                control: /* @__PURE__ */ a($, {}),
                label: t.label
              },
              t.value
            ))
          }
        ),
        (l || c.error) && /* @__PURE__ */ a(k, { children: ((d = c.error) == null ? void 0 : d.message) ?? l })
      ]
    }
  );
}, N = L, H = ({
  control: h,
  name: u,
  ...s
}) => {
  const { field: n } = m({ control: h, name: u });
  let r = n.value;
  if (r == null)
    r = !1;
  else if (typeof r != "boolean")
    throw new Error("RhfSwitch value must be boolean, null or undefined");
  return /* @__PURE__ */ a(
    E,
    {
      checked: r,
      onChange: (l, f) => {
        n.onChange(f);
      },
      onBlur: n.onBlur,
      ref: n.ref,
      ...s
    }
  );
}, Q = H, I = ({
  control: h,
  name: u,
  rules: s,
  maxCharacters: n,
  ...r
}) => {
  var o;
  const { field: l, fieldState: f } = m({ control: h, name: u, rules: s });
  let i = l.value;
  if (i == null)
    i = "";
  else if (typeof i != "string")
    throw new Error("RhfTextField value must be string, null or undefined");
  let R = ((o = f.error) == null ? void 0 : o.message) ?? r.helperText;
  return n !== void 0 && (R = /* @__PURE__ */ C(F, { component: "span", sx: { display: "flex", justifyContent: "space-between" }, children: [
    /* @__PURE__ */ a("span", { children: R }),
    /* @__PURE__ */ C("span", { children: [
      i.length,
      "/",
      n
    ] })
  ] })), /* @__PURE__ */ a(
    p,
    {
      ...r,
      name: u,
      error: !!f.error,
      onChange: l.onChange,
      onBlur: l.onBlur,
      value: i,
      inputRef: l.ref,
      helperText: R
    }
  );
}, U = I;
export {
  J as RhfAutocomplete,
  K as RhfCheckbox,
  M as RhfCheckboxGroup,
  N as RhfRadioGroup,
  Q as RhfSwitch,
  U as RhfTextField
};
